export const tagTypes = {
    favourite: 'favourite',
    prescription: 'prescription',
    patient: 'patient',
    appointments: 'appointments',
    doctor: 'doctor',
    reviews: 'reviews',
    timeSlot: 'timeSlot',
    blogs: 'blogs',
    medicine: 'medicine',
    admin: 'admin'
}

export const tagTypeList = [
    tagTypes.favourite,
    tagTypes.prescription,
    tagTypes.patient,
    tagTypes.appointments,
    tagTypes.doctor,
    tagTypes.reviews,
    tagTypes.timeSlot,
    tagTypes.blogs,
    tagTypes.medicine,
    tagTypes.admin
]